import { projectRequest } from 'store/utils/request';

export const getEntitiesFeaturesRequest = async (entityId, params) => {
  try {
    return await projectRequest.get(`/entities/${entityId}/features/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addEntitiesFeatureRequest = async (entityId, data) => {
  try {
    return await projectRequest.post(`/entities/${entityId}/features/`, data);
  } catch (error) {
    throw error;
  }
};

export const multiEntitiesFeatureRequest = async (entityId, data) => {
  try {
    return await projectRequest.post(
      `/entities/${entityId}/features/multi/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const getEntitiesFeatureRequest = async (entityId, id) => {
  try {
    return await projectRequest.get(`/entities/${entityId}/features/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const updateEntitiesFeatureRequest = async (entityId, id, data) => {
  try {
    return await projectRequest.put(
      `/entities/${entityId}/features/${id}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteEntitiesFeatureRequest = async (entityId, id) => {
  try {
    return await projectRequest.delete(`/entities/${entityId}/features/${id}/`);
  } catch (error) {
    throw error;
  }
};
